(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-free-shipping-notice"]) return;
  try {
    
  (() => {
    const noticeSelector = '[data-product-free-shipping-notice]';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const hideNotice = (notice) => {
      notice.classList.remove('is-visible');
      window.setTimeout(() => {
        notice.hidden = true;
      }, reduceMotion.matches ? 0 : 480);
    };

    const initializeNotice = (notice) => {
      if (notice.dataset.noticeInitialized === 'true') return;
      notice.dataset.noticeInitialized = 'true';

      const delay = Math.max(0, Number(notice.dataset.noticeDelay) || 0);
      const duration = Math.max(0, Number(notice.dataset.noticeDuration) || 0);
      let dismissTimer;

      const clearDismissTimer = () => window.clearTimeout(dismissTimer);
      const scheduleDismiss = () => {
        clearDismissTimer();
        if (notice.matches(':hover') || notice.contains(document.activeElement)) return;
        if (duration > 0 && !notice.hidden && notice.classList.contains('is-visible')) {
          dismissTimer = window.setTimeout(() => hideNotice(notice), duration);
        }
      };

      notice.querySelector('[data-product-free-shipping-notice-close]')?.addEventListener('click', () => {
        clearDismissTimer();
        hideNotice(notice);
      });

      notice.addEventListener('mouseenter', clearDismissTimer);
      notice.addEventListener('mouseleave', scheduleDismiss);
      notice.addEventListener('focusin', clearDismissTimer);
      notice.addEventListener('focusout', (event) => {
        if (!(event.relatedTarget instanceof Node) || !notice.contains(event.relatedTarget)) scheduleDismiss();
      });

      window.setTimeout(() => {
        notice.hidden = false;
        notice.getBoundingClientRect();
        notice.classList.add('is-visible');

        scheduleDismiss();
      }, delay);
    };

    const updateFloatingOffset = () => {
      const stickyBar = document.querySelector('.tt-fixed-product-wrapper');
      const backToTop = document.querySelector('.tt-back-to-top.tt-show');
      let stickyOffset = 0;
      let backToTopOffset = 0;

      if (stickyBar?.classList.contains('atdshowed') && window.getComputedStyle(stickyBar).display !== 'none') {
        stickyOffset = Math.ceil(stickyBar.getBoundingClientRect().height);
      }

      if (backToTop && window.getComputedStyle(backToTop).position === 'fixed') {
        backToTopOffset = Math.ceil(window.innerHeight - backToTop.getBoundingClientRect().top);
      }

      document.querySelectorAll(noticeSelector).forEach((notice) => {
        const noticeOffset = notice.classList.contains('product-free-shipping-notice--bottom-right')
          ? Math.max(stickyOffset, backToTopOffset)
          : stickyOffset;
        notice.style.setProperty('--fs-notice-bottom-offset', `${noticeOffset}px`);
      });
    };

    const initializeNotices = (root = document) => {
      root.querySelectorAll(noticeSelector).forEach(initializeNotice);
      updateFloatingOffset();
    };

    const initializeFloatingObservers = () => {
      document.querySelectorAll('.tt-fixed-product-wrapper, .tt-back-to-top').forEach((element) => {
        if (element.dataset.freeShippingObserver === 'true') return;
        element.dataset.freeShippingObserver = 'true';

        new MutationObserver(updateFloatingOffset).observe(element, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });

        if ('ResizeObserver' in window) {
          new ResizeObserver(updateFloatingOffset).observe(element);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeNotices();
        initializeFloatingObservers();
      }, { once: true });
    } else {
      initializeNotices();
      initializeFloatingObservers();
    }

    window.setTimeout(updateFloatingOffset, 500);
    window.addEventListener('resize', updateFloatingOffset, { passive: true });
    document.addEventListener('shopify:section:load', (event) => {
      initializeNotices(event.target);
      initializeFloatingObservers();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
